.ant-modal {
    &-wrap {
        z-index: 1040; // 层级要比popover的层级(1030)高
    }

    &-content {
        background-color: var(--background-system-frame-floatpanel);
        border-radius: 12px;
    }

    &-body {
        background-color: var(--background-system-frame-floatpanel);
        border-radius: 12px;
    }

    .ant-modal-close-x {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--content-system-tertiary);
    }

    &-footer {
        display: flex;
        justify-content: flex-end;
    }
}

.mt-modal-confirm {
    width: 300px !important;
    .ant-modal-body {
        padding: 11px 16px 16px;
    }
    &__body {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__icon {
        display: flex;
        margin: 12px 0;
        color: var(--content-system-info-icon-regular);
        .b-icon-font {
            margin-bottom: 12px;
        }
    }

    .ant-modal-close-x {
        width: 45px;
        height: 40px;
    }

    &__title {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--content-input);
        font-weight: 500;
        font-size: var(--font-size-md);
        &__text {
            color: var(--content-system-primary);
            font-weight: 600;
            font-size: 16px;
            text-align: center;
        }
    }

    &__content {
        margin-top: 8px;
        color: var(--content-system-tertiary);
        font-weight: 400;
        font-size: 14px;
        text-align: center;
    }

    &__actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 26px;

        &.vertical {
            flex-direction: column-reverse;
            align-items: center;

            .ant-btn {
                width: 100%;
                flex: none;
                margin: 0 0 12px;

                &:first-of-type {
                    margin-bottom: 0px;
                }
            }
        }
    }

    &__cancel,
    &__ok {
        flex: 1;
    }

    &__cancel {
        margin-right: 12px;
        background: var(--background-btn-tertiary, #f3f5f7);
    }
}
